import { readEnvMockFlag } from "@/utils/envFlag";

/** When true, use slug routes + landing.mock.ts instead of /class/api/v1/* */
export const LANDING_USE_MOCK = readEnvMockFlag(
  import.meta.env.VITE_USE_LANDING_MOCK
);
